import axios from 'axios';
import { inject } from 'mini-ioc';
import { ref } from 'vue';

import type SendRequestInterface from '@/services/SendRequest/SendRequestInterface';
import StepControllerService from '@/services/StepControllerService';
import FieldsDTO from '@/services/FieldsDTO';
import WidgetProps from '@/services/WidgetProps';
import { analytics } from '@/services/analytics';

export default class SendRequestService implements SendRequestInterface {
  public uri = '/api/v1/feedback';
  public _isPending = ref(false);

  public get isPending() {
    return this._isPending.value;
  }

  public set isPending(value: boolean) {
    this._isPending.value = value;
  }

  public constructor(
    public fields = inject(FieldsDTO),
    public widgetProps = inject(WidgetProps),
    public stepController = inject(StepControllerService),
  ) {}

  private collectUtm(url = window.location.href) {
    return Object.fromEntries(
      [...new URL(url).searchParams].filter(([key]) => key.startsWith('utm_')),
    );
  }

  private preparePhone(value: string): string {
    // Извлекаем цифры и проверяем наличие плюса
    const digitsOnly = value.replace(/\D/g, '');

    // Исправляем российские номера
    let processedDigits = digitsOnly;

    if (digitsOnly.length === 11 && digitsOnly.startsWith('89')) {
      processedDigits = '7' + digitsOnly.substring(1);
    }

    // Возвращаем с плюсом, обрезая до 15 цифр
    return '+' + processedDigits.substring(0, 15);
  }

  public send = async () => {
    if (this.isPending) return;

    this.isPending = true;

    const response = await axios.post(this.widgetProps.host + this.uri, this.getRequestBody(), {
      withCredentials: true,
    });

    this.isPending = false;

    if (!response.data.errors) {
      analytics.onContactsSend();

      this.stepController.next('sendRequest');

      return;
    }

    throw new Error('bad request');
  };

  public getRequestBody = () => {
    const modeName = this.fields.tariff?.modeDetails.find(
      (mode) => mode.tariffEc4Id === this.fields?.mode?.ec4Id,
    )?.modeName;

    const res = {
      formid: 'calculator_vue3',
      tranid: '000',
      name: this.fields.client.name,
      email: this.fields.client.email,
      phone: this.preparePhone(this.fields.client.phone),
      clientType: this.fields.client.type,
      title: 'Новая заявка на расчет (калькулятор)',
      message: `
        Город-отправитель: ${this.fields.route.cityFrom.name},
Город-получатель: ${this.fields.route.cityTo.name},
${this.fields.client.TIN ? `ИНН: ${this.fields.client.TIN},` : ''}
${
  this.fields.client.customsClearance
    ? `Таможенное оформление: ${this.fields.client.customsClearance},`
    : ''
}
Весогабариты: ${JSON.stringify(this.fields.packages)},
Тариф: ${this.fields.tariff?.serviceName},
Режим доставки: ${modeName},
Примерная стоимость: ${this.fields.mode?.deliveryPaymentDetail.totalCost},
Валюта: ${this.widgetProps.currencyMark},
        `,
    };

    const utmObject = this.collectUtm();

    const shouldAddUtm = this.widgetProps.collectUTM && Object.keys(utmObject).length > 0;

    if (shouldAddUtm) {
      Object.assign(res, {
        utm: utmObject,
      });
    }

    return res;
  };
}
